import { ref } from 'vue';

// Module-scope (singleton) state: every PhotoTile shares the same capture
// screen and camera stream instead of each mounting its own <video>/getUserMedia.
const isOpen = ref(false);
let resolveCapture: ((value: string | undefined) => void) | undefined;

export function useCameraCapture() {
  const openCamera = (): Promise<string | undefined> => {
    isOpen.value = true;

    return new Promise((resolve) => {
      resolveCapture = resolve;
    });
  };

  // Called by the CameraCapture screen itself once a photo is taken or the
  // user backs out — resolves the promise returned by openCamera().
  const resolveCameraCapture = (value: string | undefined) => {
    isOpen.value = false;
    resolveCapture?.(value);
    resolveCapture = undefined;
  };

  return { isOpen, openCamera, resolveCameraCapture };
}
